import React from "react";
import { BsWhatsapp } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoInstagram } from "react-icons/io5";
import { IoLogoTiktok } from "react-icons/io5";
import { IoLogoYoutube } from "react-icons/io";
import { Link } from "react-router-dom";

export const CustomerService = () => {
  return (
    <>
      <div className="bg-customer-service flex-center font-family-montserrat align-center flex-container">
        <div className="customer-icon txt-group1 ancho50">
          <div className="mr-auto container-atencion-al-cliente">
            <div className="font12-customer font700">Atención al cliente:</div>
            <div className="box">
              <BsWhatsapp size={35} color="#27D309" className="icon-whtp-desktop" />
              <BsWhatsapp size={18} color="#27D309" className="icon-whtp-mobile" />
              <div className="font12-telephone font500">+51 959 700 400</div>
            </div>
          </div>
        </div>

        {/* <div className="divider"></div> */}
        <div className="customer-right txt-group2 borde005e5e5 ancho50 div-nohidden font19v2 font700 margin-txt-group">
          <div className="container-100 div-nohidden txt-ofertas">
            Aprovecha las ofertas especiales y {" "}
            <span className="highlight">síguenos:</span>
          </div>
          <div className="icons-social-media div-nohidden flex-container container-100">
            <Link to="/" className="icons-social-a div-nohidden">
              <FaFacebookF size={15} color="#27D309" className="icon-social" />
            </Link>
            <Link to="/" className="icons-social-a div-nohidden">
              <IoLogoInstagram size={15} color="#27D309" className="icon-social" />
            </Link>
            <Link to="/" className="icons-social-a div-nohidden">
              <IoLogoTiktok size={15} color="#27D309" className="icon-social" />
            </Link>
            <Link to="/" className="icons-social-a div-nohidden">
              <IoLogoYoutube size={15} color="#27D309" className="icon-social" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};